import { Loader, LoaderProps } from '@mantine/core';

export const LoaderDefaultProps = (): Partial<LoaderProps> => ({
  // these are all already the default for the Loader
  color: 'cobalt',
  // DEFAULT SIZES:
  //xs: 18 X 18;
  //sm: 22 X 22;
  //md: 36 X 36;
  //lg: 44 X 44
  //xl: 58 X 58;
  size: 'md',
  variant: 'oval',
});

export { Loader };
// TODO: Update this so that it can use our custom loader
